export default "__VITE_ASSET__JdNThRRI__"